export const isMlFeatureEnabled =
  (window.REACT_APP_ENABLE_ML_FEATURE ||
    process.env.REACT_APP_ENABLE_ML_FEATURE) === 'true'
